module.exports = __webpack_public_path__ + "img/2.f425887c.png";